export const WARNING_VALIDATION_MESSAGES = {
  FREE_ASSETS_THREE_TIMES_EXPENSES:
    'Es wird empfohlen, eine frei verfügbare Reserve in Höhe von drei Monatsausgaben vorzuhalten.',
  LOANS_NOT_REDEEMED:
    'Wir empfehlen Ihnen, Kredite möglichst zu tilgen, bevor Sie Vermögen anlegen.',
};
